// Shown as plain, always-visible links at the top of the guest menu (not inside an
// expand/collapse accordion like guestMenuItems below) — these are destinations people tap
// straight to, not reference/policy pages that make sense collapsed by default.
export const quickLinkItems = [
  { name: "main.nav.cheapflights", to: "/cheap-flights" },
  { name: "main.nav.avioCelojumi", to: "/avio-celojumi" },
  // Same Waavo feature flag as TopNavigation.jsx's "Papildus" dropdown — toggled per-namespace
  // via kubectl, no code change/redeploy needed to turn it on for another tenant.
  ...(window.SERVER_DATA?.REACT_APP_ENABLE_CHARTER_IFRAME === "true"
    ? [{ name: "main.nav.travelRequest", to: "/travel-request" }]
    : []),
];

export const guestMenuItems = [
  // {
  //   name: "main.nav.discover",
  //   items: [
  //     { name: "main.nav.discover.newsletter", to: "/newsletter" },
  //     { name: "main.nav.discover.stories", to: "/stories" },
  //   ],
  // },
  {
    name: "main.nav.terms",
    items: [
      { name: "main.nav.terms.tos", to: "/info/terms-of-service" },
      { name: "main.nav.terms.privacy", to: "/info/privacy-policy" },
      { name: "main.nav.terms.refund", to: "/info/cancellation-policy" },
      { name: "main.nav.terms.guarantee", to: "/info/guarantee-rules" },
    ],
  },
  {
    name: "main.nav.company",
    items: [{ name: "main.nav.company.about", to: "/about-us" }],
  },
  {
    name: "main.nav.help",
    items: [
      { name: "main.nav.help.faq", to: "/info/faq" },
      // { name: "main.nav.help.support", to: "/support" },
    ],
  },
  {
    name: "main.nav.special.booking",
    items: [
      { name: "main.nav.business", to: "/business" },
      { name: "main.nav.groups", to: "/groups" },
    ],
  },
];
